import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

//api
import { ProjectManagementService } from "../../../../service/projectmanagement-service";

       
const ProjectTable = ({reloadList})=>{
    const navigate = useNavigate()
    const [projects, setProjects] = useState([])

    useEffect(() => {
        const fetchProjects = () => {
          ProjectManagementService.getAllProjects(
            (data)=>{
            if (data && Array.isArray(data.results)) {
                setProjects(data.results);
            } else {
                 const errorMessage = "La risposta non contiene un array valido di progetti.";
                 console.error(errorMessage);
        
            }
        },
            (error) => {
              console.error("Errore durante il recupero dei progetti: ", error);
              
            }
          );
        };
    
        fetchProjects();
    }, [reloadList]);
    
    return (
        <div className="card projectTable__TableWrapper" >
            <DataTable value={projects} tableStyle={{ minWidth: '50rem' }} className='projectTable__Table'  style={{marginRight:'2rem'}}>
                <Column field="name" header="Nome Progetto"></Column>
                <Column field="notes" header="Descrizione"></Column>
                <Column
                    header=""
                    body={(rowData) => (
                        <Button
                            label="Gestisci"
                            className="p-button-sm"
                            onClick={() => {
                                const projectId = rowData.id;
                                navigate(`/dashboard/project_management/${projectId}`);
                            }}
                        />
                    )}
                ></Column>
            </DataTable>
        </div>
    );
}

export default ProjectTable